module.exports = __webpack_public_path__ + "static/media/marica-marinovic-golubic.9ef95fa7.jpg";